import { TermScheduleFlags } from '../../course_scheduler/services/term_schedule_flags';
import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IRegisterSectionsDatasource } from '../../course_scheduler/datasources/register_sections_datasource';
import { ISection } from '../../../interfaces/scheduler_interfaces';
import { RegistrationSection } from '../../course_scheduler/builders/registration_section_builder';
import { ISectionsDatasource } from '../../sections/datasources/sections_datasource';
import { ScheduledSectionServant } from '../../course_scheduler/servants/scheduled_section_servant';
import { CrossCourseLinkedSectionServant } from '../../course_scheduler/servants/cross_course_linked_section_servant';
import { SectionStatusServant } from '../../course_scheduler/servants/section_status_servant';
import { SectionRegistrationServant } from '../../course_scheduler/servants/section_registration_servant';
import { ITermSectionTypesDatasource } from '../../term_courses/datasources/term_section_types_datasource';
import { UpdateSectionSelectionCommand } from '../../../components/section_selections/commands/update_section_selection_command';

export type UpdateSectionSelectedFlagCommand = (sectionId: ISection['id']) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .service(
    'updateSectionSelectedFlagCommand',
    function updateSectionSelectedFlagCommandDefinition(
      defineCommandORM: IDefineCommand,
      $q: ng.IQService,
      ngRegisterSectionsDatasource: IRegisterSectionsDatasource,
      ngSectionsDatasource: ISectionsDatasource,
      ngTermSectionTypesDatasource: ITermSectionTypesDatasource,
      ngTermScheduleFlags: TermScheduleFlags,
      ngCrossCourseLinkedSectionServant: CrossCourseLinkedSectionServant,
      updateSectionSelectionsCommand: UpdateSectionSelectionCommand
    ) {
      return defineCommandORM(
        'updateSectionSelectedFlagCommand',
        function updateSectionSelectedFlagCommand(deferred, sectionId: ISection['id']) {
          const section = ngSectionsDatasource.get(sectionId);
          if (!section) {
            return deferred.resolve();
          }
          let selectedFlagUpdateIds = [sectionId];
          if (SectionStatusServant.isStatusUnscheduled(section)) {
            selectedFlagUpdateIds = [];
          }

          const crossCourseLinkedSectionIds = ngCrossCourseLinkedSectionServant.getSectionIdOfLinkedCrossCourses(
            sectionId,
            ngSectionsDatasource.metasource().derived()
          );

          const scheduledSiblingSections = SectionRegistrationServant.getScheduledSiblingSections(
            section,
            ngSectionsDatasource.metasource().derived(),
            ngTermSectionTypesDatasource.values()
          );
          const scheduledSiblingSectionIds = scheduledSiblingSections.map((_section) => _section.id);

          selectedFlagUpdateIds = selectedFlagUpdateIds
            .concat(crossCourseLinkedSectionIds)
            .concat(scheduledSiblingSectionIds);

          const updateSectionSelectionPromises: ng.IPromise<IQuery[]>[] = [];
          selectedFlagUpdateIds.forEach((_sectionId) => {
            const _section = ngSectionsDatasource.get(_sectionId);
            if (_section) {
              const regSection = ngSectionsDatasource.metasource().compose(_section);
              const isSelected = ScheduledSectionServant.isEligibleForSelection(regSection, ngTermScheduleFlags);
              regSection.is_selected = isSelected;
              ngRegisterSectionsDatasource.put(regSection as RegistrationSection);
              updateSectionSelectionPromises.push(updateSectionSelectionsCommand(regSection.id, isSelected));
            }
          });

          $q.all(updateSectionSelectionPromises).then(deferred.resolve);
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/unscheduled_sections/commands/update_section_selected_flag_command.ts